import { getSupabase } from '@infra/supabase/client';

// Links públicos (indicação e formalização) geridos no Super Admin. As RPCs
// conferem o owner da plataforma; aqui só o mapeamento.
export type PublicLinkTipo = 'indicacao' | 'formalizacao';

export interface PublicLinkAdminRow {
  tipo: PublicLinkTipo;
  id: string;
  token: string | null;   // só link ativo traz token
  workspaceId: string;
  workspaceNome: string;
  pipelineId: string;
  pipelineNome: string;
  responsavelId: string | null;
  responsavelNome: string | null;
  ativo: boolean;
  expiresAt: string | null;
  createdAt: string;
}

export interface PublicLinkPipeline { id: string; nome: string; formalizacao: boolean; enterprise: boolean }
export interface PublicLinkCreated { token: string; urlPath: string; expiresAt?: string }

const client = () => {
  const supabase = getSupabase();
  if (!supabase) throw new Error('Supabase não inicializado.');
  return supabase;
};

export const publicLinksAdminRepository = {
  list: async (): Promise<PublicLinkAdminRow[]> => {
    const { data, error } = await client().rpc('admin_listar_links_publicos');
    if (error) throw error;
    return (data || []).map(r => ({
      tipo: r.tipo as PublicLinkTipo,
      id: r.id,
      token: r.token,
      workspaceId: r.workspace_id,
      workspaceNome: r.workspace_nome,
      pipelineId: r.pipeline_id,
      pipelineNome: r.pipeline_nome,
      responsavelId: r.responsavel_id,
      responsavelNome: r.responsavel_nome,
      ativo: r.ativo,
      expiresAt: r.expires_at,
      createdAt: r.created_at,
    }));
  },
  listPipelines: async (workspaceId: string): Promise<PublicLinkPipeline[]> => {
    const { data, error } = await client().rpc('admin_listar_pipelines_para_link', { p_workspace_id: workspaceId });
    if (error) throw error;
    return data || [];
  },
  create: async (tipo: PublicLinkTipo, pipelineId: string, responsavelId?: string): Promise<PublicLinkCreated> => {
    const { data, error } = await client().rpc('admin_criar_link_publico', {
      p_tipo: tipo,
      p_pipeline_id: pipelineId,
      p_responsavel_id: responsavelId || undefined,
    });
    if (error) throw error;
    const r = data as { token?: string; url_path?: string; expires_at?: string } | null;
    if (!r?.token || !r.url_path) throw new Error('Resposta vazia do admin_criar_link_publico.');
    return { token: r.token, urlPath: r.url_path, expiresAt: r.expires_at };
  },
  revoke: async (tipo: PublicLinkTipo, id: string): Promise<void> => {
    const { error } = await client().rpc('admin_revogar_link_publico', { p_tipo: tipo, p_id: id });
    if (error) throw error;
  },
};
